import React from "react";
import { InfraVestLogo } from "@/components/InfraVestLogo";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black"
    >
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <InfraVestLogo size={32} />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-neutral-400">
              InfraVest is building the on-ramp to infrastructure ownership —
              towers, fiber, and the edge.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7">
            <Col
              title="Platform"
              links={[
                { l: "Vision", h: "#vision" },
                { l: "How it Works", h: "#how" },
                { l: "Owners", h: "#owners" },
                { l: "FAQ", h: "#faq" },
              ]}
            />
            <Col
              title="Company"
              links={[
                { l: "About", h: "#vision" },
                { l: "Press", h: "#" },
                { l: "Contact", h: "#early-access" },
              ]}
            />
            <Col
              title="Legal"
              links={[
                { l: "Disclosures", h: "#disclaimer" },
                { l: "Privacy", h: "#" },
                { l: "Terms", h: "#" },
              ]}
            />
          </div>
        </div>

        <div
          id="disclaimer"
          data-testid="footer-disclaimer"
          className="mt-16 rounded-2xl border border-white/10 bg-neutral-950 p-6"
        >
          <p className="text-[11px] uppercase tracking-[0.2em] text-orange-400">
            Important disclosure
          </p>
          <p className="mt-3 text-xs leading-relaxed text-neutral-500">
            Investment opportunities, if offered, will be made only through
            compliant securities offerings and official offering documents.
            Nothing on this website constitutes an offer to sell, or a
            solicitation of an offer to buy, any security. Forward-looking
            statements are subject to risks and uncertainties.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-neutral-500 sm:flex-row sm:items-center">
          <div>© {new Date().getFullYear()} InfraVest, Inc. All rights reserved.</div>
          <div className="font-mono tracking-widest text-neutral-600">
            v0.1 · Pre-launch
          </div>
        </div>
      </div>
    </footer>
  );
};

const Col = ({ title, links }) => (
  <div>
    <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">
      {title}
    </div>
    <ul className="mt-5 space-y-3">
      {links.map((l, i) => (
        <li key={i}>
          <a
            href={l.h}
            className="text-sm text-neutral-300 transition-colors hover:text-white"
            data-testid={`footer-link-${title.toLowerCase()}-${i}`}
          >
            {l.l}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
